import { render, staticRenderFns } from "./OnGooglePlay.vue?vue&type=template&id=46e90cf4&"
import script from "./OnGooglePlay.vue?vue&type=script&lang=ts&"
export * from "./OnGooglePlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports